import productService from '../../../services/products/';
import { applicationSettings } from '../../../settings/application';
import Bror from './bror';
import Jonaxel from './jonaxel';
import Boaxel from './boaxel';
import Aurdal from './aurdal';
import Ivar from './ivar';
import Elvarli from './elvarli';

function getRange(name) {
  switch (name) {
    case 'BROR':
      return Bror;
    case 'JONAXEL':
      return Jonaxel;
    case 'BOAXEL':
      return Boaxel;
    case 'AURDAL':
      return Aurdal;
    case 'IVAR':
      return Ivar;
    case 'ELVARLI':
      return Elvarli;
    default:
      console.error('Missing range-specific implementation ');
      return {};
  }
}

function getSelectedChild(item, optionItems, switchingProp) {
  const swappableChildren = item.items.filter(
    childItem =>
      !productService.isMultiParentProduct(childItem) &&
      optionItems.some(optionItem =>
        productService.isType(childItem, optionItem.filter.type)
      )
  );

  const hasDivergentItems = !swappableChildren.every(
    childItem =>
      childItem.filter[switchingProp] ===
      swappableChildren[0].filter[switchingProp]
  );

  return {
    hasDivergentItems,
    filter: {
      [switchingProp]: swappableChildren[0].filter[switchingProp],
    },
  };
}

const rangeApi = getRange(applicationSettings.applicationName);

export const range = {
  getSelectedChild,
  ...rangeApi,
};
